import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { MCP_CREDENTIALS_API } from '../../constants/central-api';
import { submitLogToBugsnag } from '../log';

export default async function update_mcp_api_call(
  connectionId: number,
  credentials: any,
  isActive: boolean,
  oauthCode?: string,
  shouldShowMsg: boolean = true
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const isWhiteLabel = store.getState().UI?.isWhiteLabel;
    let sellerToken: string;
    if (isWhiteLabel) {
      sellerToken = accessToken?.currentWhiteLabelSellerToken;
    } else {
      sellerToken = accessToken?.sellerToken;
    }

    //* Format the credentials to add manual accounts to the credentials list
    const formatted_credentials: any = {};

    for (const key in credentials) {
      if (credentials.hasOwnProperty(key)) {
        const value = credentials[key];

        if (
          value === 'manual_account' &&
          credentials.hasOwnProperty(`${key}_manual`)
        ) {
          formatted_credentials[key] = credentials[`${key}_manual`];
        } else if (!key.endsWith('_manual')) {
          if (
            !(
              credentials[key] === 'manual_account' &&
              credentials.hasOwnProperty(`${key}_manual`)
            )
          ) {
            formatted_credentials[key] = value;
          }
        }
      }
    }

    const requestInfo: RequestInfo = {
      url: `${MCP_CREDENTIALS_API(shopSlug)}/${connectionId}`,
      method: 'PATCH',
      body: JSON.stringify({
        credentials: formatted_credentials,
        is_active: isActive,
        oauth_code: oauthCode,
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'UPDATE_MCP_CONNECTION';
    const customMsg = isActive
      ? 'Integration Connection Successful.'
      : `Integration Connection Deactivated.`;

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      shouldShowMsg,
      false,
      false,
      false,
      ['You have reached the maximum number of credentials for the free tier']
    );

    const response = res.data;

    if (res.actionType === actionType) {
      return response;
    } else {
      return {};
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
